import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { forkJoin } from 'rxjs';

import { ApiTransferConfigService } from './../../../../services/api/api-transfer-config.service';
import { ICustomSelect } from 'src/app/models/generic';
import {
  IManualBatchContractFilter,
  IManualBatchContractFilterForm
} from './../../../../models/manual-batch';

@Component({
  selector: 'app-header-actions-contract-list',
  templateUrl: './header-actions-contract-list.component.html',
  styleUrls: ['./header-actions-contract-list.component.scss']
})
export class HeaderActionsContractListComponent implements OnInit {
  @Output() searchFieldsEvent = new EventEmitter<IManualBatchContractFilter>();

  form!: FormGroup<IManualBatchContractFilterForm>;

  beneficiaryOpts: ICustomSelect[] = [];
  bankOpts: ICustomSelect[] = [];
  channelOpts: ICustomSelect[] = [];
  contractOpts: ICustomSelect[] = [];
  beneficiaryTypeOpts: ICustomSelect[] = [];

  emptyOption: ICustomSelect = { id: '', name: 'Nenhum' };

  constructor(private _batchConfigService: ApiTransferConfigService) {}

  ngOnInit(): void {
    this.getFilterOpts();
    this.buildForm();
  }

  buildForm(): void {
    this.form = new FormGroup<IManualBatchContractFilterForm>({
      Beneficiary: new FormControl<string>('', { nonNullable: true }),
      Bank: new FormControl<string>('', { nonNullable: true }),
      Channel: new FormControl<string>('', { nonNullable: true }),
      ContractStatus: new FormControl<string>('', { nonNullable: true }),
      BeneficiaryType: new FormControl<string>('', { nonNullable: true })
    });
  }

  getFilterOpts(): void {
    const bank$ = this._batchConfigService.getBank();
    const channel$ = this._batchConfigService.getChannel();
    const contract$ = this._batchConfigService.getContractStatus();
    const beneficiaryType$ = this._batchConfigService.getBeneficiaryTypes();
    const beneficiary$ = this._batchConfigService.getBeneficiaries();

    const options$ = forkJoin([
      bank$,
      channel$,
      contract$,
      beneficiaryType$,
      beneficiary$
    ]);

    options$.subscribe({
      next: ([banks, channels, contracts, beneficiaryTypes, beneficiaries]) => {
        this.bankOpts = banks;
        this.channelOpts = channels;
        this.contractOpts = contracts;
        this.beneficiaryTypeOpts = beneficiaryTypes;
        this.beneficiaryOpts = beneficiaries;
      }
    });
  }

  handleSearchFields(): void {
    this.searchFieldsEvent.emit(
      this.form.getRawValue() as IManualBatchContractFilter
    );
  }

  resetControlValue(control: string): void {
    this.form.get(control)?.setValue('');
  }
}
